import { isYWC } from './domain.constant';

export const FONT_NAME_ROBOTO = 'Roboto';
export const FONT_NAME_INTER = 'Inter';
export const FONT_NAME_WORK_SANS = 'Work Sans';

export const FONT_FAMILY_ROBOTO = `${FONT_NAME_ROBOTO}, sans-serif`;
export const FONT_FAMILY_INTER = `${FONT_NAME_INTER}, sans-serif`;
export const FONT_FAMILY_WORK_SANS = `${FONT_NAME_WORK_SANS}, sans-serif`;

export const COLOR_ERROR = '#F5222D';
export const COLOR_ERROR_100 = '#FFF1F0';
export const COLOR_SUCCESS = '#52C41A';
export const COLOR_WARNING = '#FAAD14';

export const COLOR_BASE_100 = '#FFFFFF';
export const COLOR_BASE_200 = '#E9ECF6';
export const COLOR_BASE_300 = '#DDE0ED';
export const COLOR_BASE_400 = '#C6CADB';
export const COLOR_BASE_500 = '#8B91A7';
export const COLOR_BASE_600 = '#6D7284';
export const COLOR_BASE_700 = '#444A5D';
export const COLOR_BASE_800 = '#2A3147';
export const COLOR_BASE_900 = '#101A38';

export const COLOR_SECONDARY_200 = '#F0FCF6';
export const COLOR_SECONDARY_300 = '#D3F6E6';
export const COLOR_SECONDARY_500 = '#9BE9C2';
export const COLOR_SECONDARY_600 = '#4BE4A4';
export const COLOR_SECONDARY_700 = '#3CB683';
export const COLOR_SECONDARY_900 = '#1E5B42';

export const COLOR_PRIMARY_100 = '#F3F6FF';
export const COLOR_PRIMARY_200 = '#E6EAF4';
export const COLOR_PRIMARY_300 = '#B7C1E0';
export const COLOR_PRIMARY_400 = '#8394CA';
export const COLOR_PRIMARY_500 = '#516AB6';
export const COLOR_PRIMARY_600 = '#00289F';
export const COLOR_PRIMARY_700 = '#05237A';
export const COLOR_PRIMARY_800 = '#041A5C';
export const COLOR_PRIMARY_900 = '#02123D';
export const COLOR_PRIMARY_1000 = '#01091F';

export const COLOR_PURPLE_100 = '#F9F0FF';
export const COLOR_PURPLE_300 = '#D3ADF7';
export const COLOR_PURPLE_600 = '#722ED1';

export const COLOR_BLUE_100 = '#F0F5FF';
export const COLOR_BLUE_300 = '#ADC6FF';

// YWC theme
export const YWC_PRIMARY_700 = '#E52177';
export const YWC_PRIMARY_700_TRANSPARENT = 'rgba(27, 54, 137, 0.4)';
export const YWC_PRIMARY_500_TRANSPARENT = 'rgba(229, 33, 119, 0.1)';
export const YES_SECONDARY_200 = '#F7EBE5';

// BHS theme
export const BHS_PRIMARY_700 = '#E63434';
export const BHS_PRIMARY_700_TRANSPARENT = 'rgba(230, 52, 52, 0.7)';
export const BSH_LIGHT_700 = '#F7F7F7';

// PCE theme
export const PCE_PRIMARY = '#d0006f';
export const PCE_SECONDARY = '#5a2e84';
export const PCE_PRIMARY_TRANSPARENT = 'rgba(238, 114, 171, 0)';
export const PCE_SECONDARY_TRANSPARENT = '#f5f2f8';

// PEC theme
export const PEC_PRIMARY = '#3FA1B5';
export const PEC_SECONDARY = '#124C6B';
export const PEC_PRIMARY_TRANSPARENT = '#A8DBDC';
export const PEC_SECONDARY_TRANSPARENT = '#BBDFC1';
export const PEC_ERROR = '#F4A494';
// Layout
export const SAFE_AREA_HEIGHT = 'env(safe-area-inset-top)';
// depends on logo there will be different header height for YWC app (96px) and for other apps (52px)
export const HEADER_HEIGHT = isYWC ? '75px' : `calc(52px + ${SAFE_AREA_HEIGHT})`;
export const LAYOUT_HEIGHT = `calc(100vh - ${HEADER_HEIGHT})`;

export const curewikiAntdTheme = {
  colorPrimaryBg: COLOR_PRIMARY_100,
  colorPrimaryBgHover: COLOR_PRIMARY_200,
  colorPrimaryBorder: COLOR_PRIMARY_300,
  colorPrimaryBorderHover: COLOR_PRIMARY_400,
  colorPrimaryHover: COLOR_PRIMARY_500,
  colorPrimary: COLOR_PRIMARY_600,
  colorPrimaryActive: COLOR_PRIMARY_700,
  colorPrimaryTextHover: COLOR_PRIMARY_800,
  colorPrimaryText: COLOR_PRIMARY_900,
  colorPrimaryTextActive: COLOR_PRIMARY_1000,
};
